import { registerTourProduct } from '../onboardingTourFactory';

/**
 * The tour of the "Home" page.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} {steps: [...], novusPagePath: string|false }
 */
const createTour = (t) => {
  return {
    novusPagePath: 'home',
    /* Workaround for the overlapping background. */
    highlightClass: 'fixed-element-disable-background',
    steps: [
      {
        element: '.onboarding-tour.user-drop-down',
        intro: t(
          "Let's start with the basics - you can change the dashboard's language by clicking on your profile."
        ),
        novusTrackingId: 'home-user-drop-down'
      },
      {
        element: '.onboarding-tour.menu-list-container',
        intro: t(
          'With this navigation menu, you can access the dashboard features available to you.'
        ),
        novusTrackingId: 'home-side-menu'
      }
    ]
  };
};

export const tourName = 'homePageTour';
registerTourProduct(tourName, createTour);



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/homePageTour.js